import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NavigationTabs from "./NavigationTabs";
import ScanButton from "./ScanButton";


export default class Navigation extends Component {

	static propTypes = {
		status: PropTypes.object,
		data: PropTypes.object,
		selectedProject: PropTypes.object,
		isRunning: PropTypes.bool,
		lastRun: PropTypes.string,
		newLabelsCount: PropTypes.number
	};

	render() {
		const {status, data, selectedProject, isRunning, lastRun, newLabelsCount} = this.props;

		return (
			<div className="card-header">
				<h5>Last
					scan: <small>{isRunning ? 'is running...' : lastRun}</small>
				</h5>
				<ScanButton status={status} data={data} selectedProject={selectedProject}/>
				<NavigationTabs
					newLabelsCount={newLabelsCount}
					updatedLabelsCount={data.project.codeScan.updatedLabels.length}
					notFoundLabelsCount={data.project.codeScan.notFoundLabels.filter(notFoundLabel => notFoundLabel.label.ignoreforscan !== true).length}/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/Navigation.js